import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';

export function setAguardando(aguardando) {
    return {
        type: 'DASHBOARD_ESTOQUE_FISICO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {    
    const request = axios.get(`${consts.API_URL}/abacontrol/estoque`);
    return {
        type: 'DASHBOARD_ESTOQUE_FISICO_LISTADO',
        payload: request
    };
}
